import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles,useTheme } from '@material-ui/styles';
import {
	AppBar,
	Box,
	CircularProgress,
	Divider,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Tab,
	Tabs,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,	
    Button,
	IconButton,
	Typography,
	Table,
	TableBody,
	TableCell, 
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	Slide 
} from '@material-ui/core';

import { 
  ViewState,
  EditingState,
  IntegratedEditing 
} from '@devexpress/dx-react-scheduler';

import {
  Scheduler,
  WeekView,
  DayView,  
  MonthView,
  Toolbar,
  Appointments,
  AppointmentForm,
  AppointmentTooltip,
  ConfirmationDialog,  
  DateNavigator,
  viewSwitcher,
  TodayButton,
  Resources,  
} from '@devexpress/dx-react-scheduler-material-ui';

import SettingsIcon from '@material-ui/icons/Settings';
import PermDataSettingIcon from '@material-ui/icons/PermDataSetting';
import CancelIcon from '@material-ui/icons/Cancel';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { Icon, InlineIcon } from '@iconify/react';
import StravaIcon from '@iconify/icons-mdi/strava';

import $ from "jquery";
import _ from 'lodash';
import axios from 'axios';
import auth from '../../../../utils/auth';
import { useTranslation } from 'react-i18next'

import { 
	ActivityStream,
	PowerCurve,
	PowerZone, 
	HeartrateZone,
	Interval, 
	Lap,
	Metabolism
} from "../../Chart";

//import $ from "jquery";
//var CanvasJS = window.CanvasJS;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%'
  },
  tab: {
    backgroundColor: 'white',
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
    borderRadius: '4px 4px 0 0' 
  }, 
  tabPanel: {
  	padding: '16px 16px',
    backgroundColor: 'white',
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
    borderRadius: '0 0 4px 4px',
    [theme.breakpoints.down("md")]: {
			padding: '8px 8px',
		},
  },	
  timeTableCell: {
    height: "160px",
    [theme.breakpoints.down("md")]: {
      height: "100px",
    }
  },
  appointment : {
    color:'#ffffff',
    fontSize: '14px', 
    lineHeight: '18px', 
    borderRadius: '4px',
    padding:'6px 4px',
    textAlign: 'center',
    [theme.breakpoints.down("md")]: {
      borderRadius: '2px',
    }
  },
	tableContainer: {
		width:'auto',
		height:'auto',
    [theme.breakpoints.down("lg")]: {
			marginTop: '-2px',
			height:'auto',
		},
	},
	tableRow: {
    "&$selected:selected": {
      background: "#d8efed"
    }
	},
	tableHeadCell: {
		padding:'12px 8px', 
		color:'#4db6ac',		
		fontSize:'13px',
		fontWeight:'400',
		backgroundColor:'#f9f9f9',
		whiteSpace: 'nowrap',
    [theme.breakpoints.down("md")]: {
	    padding: '4px 6px',
			fontSize:'11px'
		},
	},
	tableCell: {
		fontSize:'13px',
		padding:'12px 8px',
		whiteSpace: 'nowrap',
		[theme.breakpoints.down("md")]: {
	    padding: '4px 6px',
			fontSize:'12px'
		},
	},
	tableCellActivity: {
		display:'inline-block',
		fontSize:'13px',
		padding:'12px 8px',
		whiteSpace:'nowrap',
		textOverflow:'ellipsis',
		width:'fill-available',
		overflow:'hidden',
		maxWidth:'400px',
    [theme.breakpoints.down("md")]: {
			padding: '4px 6px',
			fontSize:'12px',
			maxWidth:'240px',
		},
	},
	dialogActivityName : {
		width:'100%',
		textAlign:'left', 
		fontSize:'18px',
		whiteSpace:'nowrap',
		textOverflow:'ellipsis',
		overflow:'hidden',
		[theme.breakpoints.down("md")]: {
			fontSize:'13px'
		},	
	},
	dialogTabs : {
		background:'#f5f5f5',
		borderRadius: '4px'
	},
	smallButton: {
		minWidth:'30px',
		padding:'0px',
		fontSize:'13px',
		color:'#cccccc' 
	},
	stravaButton : {		
		minWidth:0, margin:'2px 2px 2px 0'
	},
	stravaIcon: {
		color:'#FC4C02',
		fontSize:'16px',
		opacity:'0.7',
		marginTop:'-2px'
	},
	stravaLink: {
		color:'#FC4C02'
	},
	modifyLink: {
		color:'#888888',
		marginRight:'16px',
		cursor:'pointer'
	},
	descTitle: {
		fontSize:'12px', 
		marginTop:'10px',
		textAlign:"center"
	},
	paginationSpacer: {
		flex: '1 1 0%', 
		padding:'0 8px 8px 8px'
	},
	modifyButton: {
		border:'1px #dddddd solid',
		borderRadius:'4px',
		color:'#4db6ac',
		margin:'8px 0'
	},
	activityTitleBlock: {
		position:'relative',
		zIndex: 10, 
		width:'calc(100% + 16px)',
		flexGrow: 1, 
		height:'36px',
		margin:'0px 0 -12px -2px',	
	},	
	activityTitleCloseButton: {
		width:'32px',
		height:'32px', 
		marginLeft:'8px',
		padding:'4px',
	},
	activityTitleButton: {
		display:'inline-block',
		width:'calc(100% - 40px)',
		boxSizing: 'border-box',
		border: 'none',
		whiteSpace:'nowrap',
		textOverflow:'ellipsis',
		overflow:'hidden',
		fontSize:'15px', color:'#455a64',
		padding:'4px 0 6px 0',
		textAlign:'center',
		[theme.breakpoints.down("md")]: {
			textAlign:'left',
			fontSize:'13px',
			height:'32px', 
			padding:'4px 0 6px 0',
		},
	},	
	dialogAction : {
		background:'#f5f5f5'
	}
}));

const Activities = props => {

	//다국어적용 {t('page.key')}
	//특수한 훈련을 했을 때, 상세분석탭이 추가로 뜨게 된다. 
	//FTP테스트분석
	//FATMAX 최적화 훈련 
	//로우케이던스 훈련 
	//고강도 최적화 훈련 = 사일러이펙트
	//Break Away 훈련 = 성냥개비 
	//에어로분석 (ITT) = 공기저항값 
	//힐리핏트레이닝
	//구간PR시도

	const { t }  = useTranslation(['page']);

	const extraInfo = auth.getExtraInfo();

	//unit default
	const unit = extraInfo.unit ? extraInfo.unit : 'metric';
	const kmToMile = 0.621371;  
	const mToFeet = 3.28084;  
	const kgToLbs = 2.20462;  

	const columns = [
		{ id: 'activity_name', label: t('Dashboard.activity'), minWidth: 220 },
		{ id: 'average_watts', label: t('Dashboard.avgPower'), minWidth: 95 },

		{ id: 'distance', label: t('Dashboard.distance'), minWidth: 74 },
		{ id: 'moving_time', label: t('Dashboard.duration'), minWidth: 74 },
		{ id: 'ride_data', label: t('Dashboard.date'), minWidth: 110 },
		{ id: 'tss_text', label: t('Dashboard.score3'), minWidth: 170 },
		{ id: 'activity_update', label: '', minWidth: 175, align: 'right' },
		{ id: "activity_url", label: '', minWidth: 0, display: 'none' },
		{ id: "activity_id", label: '', minWidth: 0, display: 'none' },
		{ id: "activity_desc", label: '', minWidth: 0, display: 'none' },
	];

	const { dashboardData, wkgSelect, pdcData, locale } = props;

	const [ page, setPage ] = React.useState(0);
	const [ rowsPerPage, setRowsPerPage ] = React.useState(20);
	const [ activityUpdateOpen, setActivityUpdateOpen ] = React.useState(false);

	const [ activityId, setActivityId ] = React.useState(props.activityId); 
	const [ activityName, setActivityName ] = React.useState(''); 

	const [ chartType, setChartType ] = React.useState(''); 	
	const [ dialogActivityId, setDialogActivityId ] = React.useState(0); 
	const [ dialogActivityName, setDialogActivityName ] = React.useState(''); 
	const [ activityReload, setActivityReload ] = React.useState('stop');
	const [ activityDialog, setActivityDialog ] = React.useState(false);
	const [ activityDesc, setActivityDesc ] = React.useState(null);
	const [ streamDataJson, setStreamDataJson] = useState([]);
	const [ circle, setCircle ] = useState(false);

	const activityData = dashboardData.activityData;
	const weight = dashboardData.weight;

	const [tabSelect, setTabSelect] = React.useState(0);

	const handleTabList = (event, newTab) => {
    setTabSelect(newTab);
  };   
    
  function TabList(props) {
    return (
      <Tabs
        value={tabSelect}
        onChange={handleTabList}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab key={0} label={"LIST"} />	
        <Tab key={1} label={"CALENDAR"} />	
      </Tabs>
    );
  }



/**********************************************************/
/**********************************************************/
/**********************************************************/
/**********************************************************/
//scheduler
/**********************************************************/
/**********************************************************/
/**********************************************************/
/**********************************************************/


	const schedulerData = [];
	const currentDate = Date('Y-m-d');
	const rideIntensity = "rideIntensity";
	const powerZoneActivities = dashboardData.hasOwnProperty('powerzoneData') ? dashboardData.powerzoneData.powerzone_activities : null;

	const powerZoneResources = [
    {
      fieldName: 'rideIntensity',
      title: 'RideIntensity',
      allowMultiple: false,
      isMain: true, 
      instances: [
        { id: 'ALLOUT', text: t('Animals.type.allout'), color: '#ec3372' },
				{ id: 'SPT', text: t('Animals.type.spt'), color: '#f06292' },
        { id: 'HIIT', text: t('Animals.type.hiit'), color: '#ff7e75' }, 
        { id: 'VO2MAX', text: t('Animals.type.vo2max'), color: '#ffa75c' },
        { id: 'RPT', text: t('Animals.type.rpt'), color: '#ffd357' }, 			
        { id: 'SST', text: t('Animals.type.sst'), color: '#b0d36d' }, 
        { id: 'TEMPO', text: t('Animals.type.tempo'), color: '#b0d36d' }, 
        { id: 'HVLI', text: t('Animals.type.hvli'), color: '#76b5e8' }, 
        { id: 'BASE', text: t('Animals.type.base'), color: '#76b5e8' }, 
        { id: 'POL', text: t('Animals.type.pol'), color: '#76b5e8' }, 
        { id: 'PRMD', text: t('Animals.type.prmd'), color: '#b0d36d' }, 
        { id: 'RECV', text: t('Animals.type.recv'), color: '#aaaaaa' }, 
        { id: 'ETC', text: t('Animals.type.etc'), color: '#aaaaaa' }, 
        { id: 'BAL', text: t('Animals.type.bal'), color: '#4db6ac' },
      ],
    }
  ];

  const TimeTableCell = (props) => {
    const classes = useStyles();

//		console.log(props.startDate);

    return <MonthView.TimeTableCell {...props} className={classes.timeTableCell} />;
  };
  /*
  const TimeLabel = (props) => {
    const classes = useStyles();
    return <DayView.TimeScaleLabel {...props} className={classes.timeLabel} />;
  };
  const TickCell = (props) => {
    const classes = useStyles();
    return (
      <DayView.TimeScaleTickCell {...props} className={classes.timeTableCell} />
    );
  };
  */

  const Appointment = (props) => {
    const classes = useStyles();
    const tssText = props.data.tss_text; 
    const activityId = props.data.activity_id;
		const activityName = props.data.activity_name;
    const avgPower = props.data.average_watts;
    const distance = props.data.distance;
    const movingTime = props.data.moving_time; 
    const rideType = props.data.ride_type;

    return (
      <Appointments.Appointment 
        {...props} 
        className={classes.appointment}       
				onClick={() => {
						setChartType('stream');
						setActivityDialog(true);
						setActivityId(activityId);
						setActivityName(activityName);
					}
				}
			>
        {props.children}
      </Appointments.Appointment>
    );
  };

  const AppointmentContent = (props) => {
    const classes = useStyles();
    const tssText = props.appointmentData.tss_text; 
    const activityName = props.appointmentData.activity_name;
    const avgPower = props.appointmentData.average_watts;
    const distance = props.appointmentData.distance;
    const movingTime = props.appointmentData.moving_time; 
    const rideType = props.appointmentData.ride_type;

    return (
      <AppointmentTooltip.Content 
        {...props} 
        className={classes.appointmentContent}       
      >
        <div>{tssText}</div>
        <div>{avgPower}</div>
        <div>{distance}</div>
        <div>{movingTime}</div>
      </AppointmentTooltip.Content>
    );
  };
  

  _.each(activityData, function(item, id) {

    let startTs = (Number(item.timestamp)*1000);
    let sd = new Date(startTs);
    let sd_month = (Number(sd.getMonth()) + 1) > 9 ? (Number(sd.getMonth()) + 1) : "0" + String(Number(sd.getMonth()) + 1); 

    let startDate = new Date(sd.getFullYear(), sd.getMonth(), sd.getDate(), sd.getHours(), sd.getMinutes(), sd.getSeconds());
    
//    sd.getFullYear() + "-" + sd_month + "-" + sd.getDate() + "T" + sd.getHours() + ":" + sd.getMinutes();
    
    let endTs = (Number(item.timestamp)*1000 + Number(item.elapsed_time)*1000);
    let ed = new Date(endTs);
    let ed_month = (Number(ed.getMonth()) + 1) > 9 ? (Number(ed.getMonth()) + 1) : "0" + String(Number(ed.getMonth()) + 1); 
    let endDate = new Date(ed.getFullYear(), ed.getMonth(), ed.getDate(), ed.getHours(), ed.getMinutes(), ed.getSeconds());

    //powermeter 체크 
    let rideIntensity = 'ETC';
    let rideAnimal = "🦆";

    if(Number(item.max_watts) > 0 && powerZoneActivities.hasOwnProperty(String(item.activity_id))) {
      let type = powerZoneActivities[String(item.activity_id)].type; 
      rideIntensity = type;

      if(type === "SPT") rideAnimal = "🦁";
      else if(type === "HIIT") rideAnimal = "🐆";
      else if(type === "VO2MAX") rideAnimal = "🐺";
      else if(type === "RPT") rideAnimal = "🐴";
      else if(type === "SST") rideAnimal = "🐗";
      else if(type === "TEMPO") rideAnimal = "🐷";
			else if(type === "BAL") rideAnimal = "🐶";
      else if(type === "HVLI") rideAnimal = "🐫";
      else if(type === "BASE") rideAnimal = "🐮";
      else if(type === "POL") rideAnimal = "🐘";
      else if(type === "PRMD") rideAnimal = "🦌";
      else if(type === "RECV") rideAnimal = "🐢";
      else {
        rideIntensity = "ETC";
        rideAnimal = "🦆";
      }

	  if(item.etc === "ramptest20" || item.etc === "maptest150" || item.etc === "ftptest" ) {
		  rideIntensity = type = "ALLOUT";;
			rideAnimal = "🎯";
		}

    }

    item.id = item.activity_id;
//    item.title = (window.innerWidth > 540) ? (rideAnimal + " " + item.activity_name) : rideAnimal;
    item.title = rideAnimal + " " + item.activity_name;
    item.startDate = startDate;
    item.endDate = endDate;
    item.rideIntensity = rideIntensity;

    schedulerData.push(item);
  });







/**********************************************************/
/**********************************************************/
/**********************************************************/
/**********************************************************/
//table
/**********************************************************/
/**********************************************************/
/**********************************************************/
/**********************************************************/


	let exclude_arr = Array();
	let dst_arr = Array();
	let tss_arr = Array();
	let if_arr = Array();

	let rows = Array();
	let selectedRows = Array();

	const timeout = (delay) => {
		return new Promise( res => setTimeout(res, delay) );
	}
	
	useEffect(() => {	
		const getActivityStream = () => {
			const auth_str = 'Bearer '.concat((auth.getToken().token)); 

      setCircle(true);
			setStreamDataJson([]);
      
			let url = `${process.env.REACT_APP_RESTAPI_BASE_URL}/json-api/get-activity-stream.php`; 	
			let user = auth.getUserInfo();	

			if(user.ID === 2) {
				axios.get(
					url, 
					{ 
						headers: { Authorization: auth_str }, 
						params: { 
							order:'get_stream',
							activity_id: activityId
						}
					}
				).then(async function (response) {
					setCircle(false);
	
					const data = response.data;
					if(data) {
						setStreamDataJson(data);
					}
				});
			}	else {
				axios.get(
					url, 
					{ 
						headers: { Authorization: auth_str }, 
						params: { 
							order:'get_stream',
							activity_id: activityId
						}
					}
				).then(async function (response) {
					setCircle(false);
	
					const data = response.data;
					if(data) {
						setStreamDataJson(data);
					}
				});
			}	

		}	

		if(activityId > 0 && chartType === 'stream') {
			getActivityStream();
		} 
		

	}, [activityId]);  

	if(activityData) _.each(activityData, function(item, i) { 
		let watts_str = item.average_watts  + " w ";
		if(wkgSelect) watts_str = Math.round((item.average_watts/item.weight)*10)/10  + " w/kg ";

		if(item.max_watts > 0 && item.exclude == 0) {
			watts_str += "⚡";
  	} else if(item.max_watts > 0 && item.exclude == 1) {
			watts_str += "❔";
			exclude_arr.push(Number(item.activity_id));
		} 

		let activity_name =	item.activity_name;  
		let average_watts =	watts_str; 
		let distance = (unit === 'metric') ? item.distance + " km" : Math.round(item.distance*kmToMile*100)/100 + " mi" ;
		let distance_number = item.distance;
		let moving_time = secondsToHms(item.moving_time);
		let ride_data =	item.start_date; 
		let activity_url = 'https://www.strava.com/activities/' + item.activity_id;
		let activity_id =	item.activity_id;
		let timestamp =	item.timestamp;
		let updated_at = item.updated_at;
		let ftp = item.ftp;
		let np = item.np;
		let intensity = item.intensity;
		let tss = (item.tss == 0) ? 1 : item.tss;

		let tss_text = '📊 '+ t('Dashboard.np') + ' ' + np + ', ' + t('Dashboard.if') + ' ' + intensity + ', ' + t('Dashboard.tss') + ' ' + tss;
		let synopsis_text =	item.synopsis_text;
		let anaerobic_text =	item.anaerobic_text;
		let aerobic_text =	item.aerobic_text;
		let power_text =	item.power_text;
		let	activity_desc = { 
			synopsis_text : synopsis_text, 
			anaerobic_text : anaerobic_text, 
			aerobic_text : aerobic_text, 
			power_text : power_text 
		};	

		//일주일이 지났으면 
		let updated_check = (updated_at < (parseInt(Date.now()/1000) - 60*60*6*1));
		let activity_update = (updated_check) ? true : false;

		let	d = { activity_name, average_watts, distance, moving_time, ride_data, tss_text, activity_update, activity_url, activity_id, activity_desc };	
		rows.push(d);

		dst_arr.push([i, distance_number]);
		tss_arr.push([i, tss]);
		if_arr.push([i, intensity*100]);

		selectedRows.push({activity_id : false});
	});

	const classes = useStyles();

 	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };	

  /*
	const handleClickTableAway = () => {
		setActivityName('');
		setActivityId(0);
  };
  */

	function secondsToHms(time) {
		let d = Number(time);
		let h = Math.floor(d / 3600);
		let m = Math.floor(d % 3600 / 60);
		let s = Math.floor(d % 3600 % 60);
		
		if(h > 0) {
			let hd = h > 0 ? h + "h " : "";
			let md = m > 0 ? m + "m" : "";
			
			return hd + md; 
		} else if(h <= 0) {
			let md = m > 0 ? m + "m " : "";
			let sd = s > 0 ? s + "s" : "";
			
			return md + sd; 
		}
	}

	function secondsToHmsLabel(time) {
		let d = Number(time);
		let h = Math.floor(d / 3600);
		let m = Math.floor(d % 3600 / 60);
		let s = Math.floor(d % 3600 % 60);
		
		if(h == 0 && m == 0 && s == 0) {
			return ""; 
		} else if(h > 0) {
			let hd = h > 0 ? h + ":" : "00";
			let md = m > 0 ? m : "00";
			
			return hd + md; 
		} else if(h <= 0) {
			let md = m > 0 ? m + ":" : "00";
			let sd = s > 0 ? s : "00";
			
			return md + sd; 
		} 
	}

	function TablePaginationActions(props) {
		const classes = useStyles();
		const theme = useTheme();
		const { count, page, rowsPerPage, onChangePage } = props;
	
		const handleFirstPageButtonClick = (event) => {
			onChangePage(event, 0);
		};
	
		const handleBackButtonClick = (event) => {
			onChangePage(event, page - 1);
		};
	
		const handleNextButtonClick = (event) => {
			onChangePage(event, page + 1);
		};
	
		const handleLastPageButtonClick = (event) => {
			onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
		};
	
		return (
			<div className={classes.root}>
				<IconButton
					onClick={handleFirstPageButtonClick}
					disabled={page === 0}
					aria-label="first page"
				>
					{theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
				</IconButton>
				<IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
					{theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
				</IconButton>
				<IconButton
					onClick={handleNextButtonClick}
					disabled={page >= Math.ceil(count / rowsPerPage) - 1}
					aria-label="next page"
				>
					{theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
				</IconButton>
				<IconButton
					onClick={handleLastPageButtonClick}
					disabled={page >= Math.ceil(count / rowsPerPage) - 1}
					aria-label="last page"
				>
					{theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
				</IconButton>
			</div>
		);
	}
	
	TablePaginationActions.propTypes = {
		count: PropTypes.number.isRequired,
		onChangePage: PropTypes.func.isRequired,
		page: PropTypes.number.isRequired,
		rowsPerPage: PropTypes.number.isRequired,
	};

	function handleDialogClose() {
		setActivityUpdateOpen(false);	
	}

	function handleDialogOpen(e, id, name) {
    e.stopPropagation(); 
    setActivityId(0);
    setActivityName('');
    setDialogActivityId(id);
    setDialogActivityName(name);
    setActivityUpdateOpen(true);
  }

	const setActivity = (activity_id, order) => {
		setActivityReload('loading');	
		const auth_str = 'Bearer '.concat((auth.getToken().token)); 
	
		axios.post(`${process.env.REACT_APP_RESTAPI_BASE_URL}/json-api/set-activity.php`, 
			{	order : order, activity_id: activity_id,	},
			{ headers: { Authorization: auth_str } }
		).then(function (response) {
			let res = response.data;
			if (res.success === true && res.activity_id === activity_id) {
				props.history.push({
					pathname: "/",
				});
			} else  {
				alert('Error');
			}
		}).catch((err) => {
			console.log(err);
		});
	}


	function Row(props) {
		const { activity_id, row, i } = props;
		const classes = useStyles();
		
		const isSelected = (activityId == activity_id) ? true : false; 

		return (
			<React.Fragment>
			<TableRow hover role="checkbox" tabIndex={-1} 
				key={row.activity_id} 
				selected={isSelected} 
				classes={{ selected: classes.selected }}
				className={classes.tableRow} 
				onClick={() => {
						setChartType('stream');
						setActivityDialog(true);
						setActivityDesc(row.activity_desc.synopsis_text);
						setActivityId(row.activity_id);
						setActivityName(row.activity_name);
					}
				}
			>
				{columns.map(column => {
					const value = row[column.id];

					if(column.id === 'activity_name') {
						return (
							<TableCell key={column.id} align={column.align} className={classes.tableCellActivity}>
								<Button color="secondary" size="small" variant="text" target="_blank" href={row.activity_url} className={classes.stravaButton}>
									<Icon icon={StravaIcon} className={classes.stravaIcon} />
								</Button>
								{column.format && typeof value === 'number' ? column.format(value) : value}
							</TableCell>
						);
					} else if(column.id === "activity_update") {
						return (
							<TableCell key={column.id} align={column.align} className={classes.tableCell}>
								{
									(value === true) ? 
									<a className={classes.modifyLink} onClick={e => handleDialogOpen(e, row.activity_id, row.activity_name)}>
										Modify
									</a> : ""
								}

								<a color="secondary" size="small" variant="text" target="_blank" href={row.activity_url} className={classes.stravaLink}>
								View on Strava
							</a>
							</TableCell>
						);
					} else if(column.display != 'none') {
						return (
							<TableCell key={column.id} align={column.align} className={classes.tableCell}>
								{column.format && typeof value === 'number' ? column.format(value) : value}
							</TableCell>
						);
					} 
				})}
			</TableRow>
			</React.Fragment>
		);
	}

  const handleClickOpen = () => {
    setActivityDialog(true);
  };

  const handleClose = () => {
    setActivityDialog(false);
  };


	//자식으로부터 activity_id 전달받기 
	const handlePeakActivity = (id) => {
		//검색해야지. 
		if(activityData) _.each(activityData, function(item, i) { 
			if(Number(item.activity_id) === Number(id)) {
				setActivityDesc(item.synopsis_text);
				setActivityId(item.activity_id);
				setActivityName(item.activity_name);

				setPage(Math.floor(i/rowsPerPage));

				return true;
			}
		});
		return false;
	}	

  function ChartContent() {
		$("#chartContainer").remove();
			
		if(circle === true) { 
			//stream 불러올 때 로딩써클
			return (
        <React.Fragment>
          <Box style={{minHeight:'436px', textAlign:'center', padding:'100px'}}>
            <CircularProgress size={128} color="secondary" />
          </Box>
        </React.Fragment>
      );		
    } else if(chartType === "powercurve") {
			if(0) {
				return (
					<React.Fragment></React.Fragment>
				);
			} else {
				return (
					<React.Fragment>
						<PowerCurve 
							extraInfo={auth.getExtraInfo()} 
							activityId={activityId} 
							activityName={activityName} 
							activityDesc={activityDesc} 
							handlePeakActivity={handlePeakActivity} 
							ftp={Math.round(dashboardData.ftp)} 
							wPrime={Math.round(dashboardData.wPrime)} 
							forte={dashboardData.forte} 
							pdcData={dashboardData.pdcData} 
							activityData={dashboardData.activityData} 
							streamDataJson={streamDataJson} 
							yScaleMax={dashboardData.yScale} 
							lastTs={dashboardData.lastTs} 
							prevTs={dashboardData.prevTs} 
							wkg={wkgSelect}
							weight={dashboardData.weight}
						/>
					</React.Fragment>
				);
			}
		} else if(chartType === "powerzone") {
			return (
				<React.Fragment>
					<PowerZone 
						extraInfo={auth.getExtraInfo()} 
						activityId={activityId} 
						activityName={activityName} 
						activityDesc={activityDesc} 
						ftp={Math.round(dashboardData.ftp)} 
						activityData={dashboardData.activityData} 
						streamDataJson={streamDataJson} 
						wkg={wkgSelect}
						weight={dashboardData.weight}
						powerzoneData={dashboardData.powerzoneData} 
					/>
				</React.Fragment>
			);
		} else if(chartType === "hrzone") {
			return (
				<React.Fragment>
					<HeartrateZone
						extraInfo={auth.getExtraInfo()} 				 
						activityId={activityId} 
						activityName={activityName} 
						activityDesc={activityDesc} 
						ftp={Math.round(dashboardData.ftp)} 
						activityData={dashboardData.activityData} 
						streamDataJson={streamDataJson} 
						wkg={wkgSelect}
						weight={dashboardData.weight}
						maxHr={dashboardData.maxHr}
						powerzoneData={dashboardData.powerzoneData} 
					/>
				</React.Fragment>
			);
		} else if(chartType === "interval") {
			return (
				<React.Fragment>
					<Interval 
						extraInfo={auth.getExtraInfo()} 
						activityId={activityId} 
						activityName={activityName} 
						activityDesc={activityDesc} 
						ftp={Math.round(dashboardData.ftp)} 
						activityData={dashboardData.activityData} 
						streamDataJson={streamDataJson} 
						wkg={wkgSelect}
						weight={dashboardData.weight}
						maxHr={dashboardData.maxHr}
						powerzoneData={dashboardData.powerzoneData} 
					/>
				</React.Fragment>
			);
		} else if(chartType === "lap") {
			return (
				<React.Fragment>
					<Lap
						extraInfo={auth.getExtraInfo()} 
						activityId={activityId} 
						activityName={activityName} 
						activityDesc={activityDesc} 
						ftp={Math.round(dashboardData.ftp)} 
						activityData={dashboardData.activityData} 
						streamDataJson={streamDataJson} 
						wkg={wkgSelect}
						weight={dashboardData.weight}
						maxHr={dashboardData.maxHr}
					/>
				</React.Fragment>
			);
		} else if(chartType === "metabolism") {
			return (
				<React.Fragment>
					<Metabolism 
						extraInfo={auth.getExtraInfo()} 
						activityId={activityId} 
						activityName={activityName} 
						activityDesc={activityDesc} 
						ftp={Math.round(dashboardData.ftp)} 
						activityData={dashboardData.activityData} 
						streamDataJson={streamDataJson} 
						metabolismArray={dashboardData.metabolismArray} 
						wkg={wkgSelect}
						weight={dashboardData.weight}
						maxHr={dashboardData.maxHr}
					/>
				</React.Fragment>
			);
		} else {
			//activity stream 
       return (
        <React.Fragment>        
          <ActivityStream
						extraInfo={auth.getExtraInfo()} 
            ftp={Math.round(dashboardData.ftp)} 
            wPrime={Math.round(dashboardData.wPrime)} 
            activityData={dashboardData.activityData} 
            lastTs={dashboardData.lastTs} 
            prevTs={dashboardData.prevTs}
            summaryData={dashboardData.summaryData}
            streamDataJson={streamDataJson} 
						pdcData={dashboardData.pdcData}
						powerzoneData={dashboardData.powerzoneData} 
						wkg={wkgSelect}
            weight={dashboardData.weight}						
          />
        </React.Fragment>
      );
		}
  }


	const handleTabChart = (event, value) => {
    setChartType(value);	
  };

  return (		
    <div className={classes.root}>
      <AppBar position="static" color="default" className={classes.tab}>
        <TabList />       
      </AppBar>

			<Box className={classes.tabPanel}>
			{
				(tabSelect === 1)
				?
				<React.Fragment>
					<Scheduler data={schedulerData} firstDayOfWeek={1} locale={locale}>
						<ViewState defaultCurrentDate={currentDate} />

	{/*
						<EditingState onCommitChanges={false} />
						<IntegratedEditing />                
						<ConfirmationDialog />
						<AppointmentTooltip
							//showOpenButton
							//showDeleteButton
						/>
						<AppointmentForm />     

												timeScaleLabelComponent={TimeLabel}
							timeScaleTickCellComponent={TickCell}
						<AppointmentTooltip
							contentComponent={AppointmentContent}
	//            showCloseButton
							//headerComponent={Header}
							//commandButtonComponent={CommandButton}
							//showOpenButton
							//showDeleteButton
						/>
*/}

						<MonthView 
							timeTableCellComponent={TimeTableCell}
						/>
						<Toolbar />
						<DateNavigator onNavigate={forward => () => {console.log(0);}} />
						<TodayButton />
						<Appointments appointmentComponent={Appointment} />					
						<Resources
							data={powerZoneResources}
							mainResourceName={rideIntensity}
						/>                
					</Scheduler>
				</React.Fragment>
				:				
				<React.Fragment>
					<TableContainer className={classes.tableContainer}>
						<Table stickyHeader aria-label="sticky table">
							<TableHead>
								<TableRow>
									{columns.map(column => (
										<TableCell
											key={column.id}
											align={column.align}
											className={classes.tableHeadCell}
											style={{ minWidth: column.minWidth, width: column.width, display: column.display }}
										>
											{column.label}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => (								
									<Row key={row.activity_id} activity_id={row.activity_id} row={row} i={i} />								
								))}
							</TableBody>
						</Table>
					</TableContainer>
					<TablePagination
						classes={{spacer: classes.paginationSpacer}} 
						rowsPerPageOptions={[]}
						component="div"
						count={rows.length}
						rowsPerPage={rowsPerPage}
						page={page}
						onChangePage={handleChangePage}
						onChangeRowsPerPage={handleChangeRowsPerPage}
						ActionsComponent={TablePaginationActions}
					/>
				</React.Fragment>
			}
			</Box>


			<Dialog open={activityUpdateOpen} onClose={handleDialogClose}>
					<DialogTitle className={classes.dialogActivityName}>{"'" + dialogActivityName + "' " + t('Dashboard.modifyActivity')}</DialogTitle>
					<Divider />
					<DialogContent>
					{
					(activityReload === 'loading') ? 
						<React.Fragment>
							<Box className={classes.circularProgress} style={{minWidth:'300px', padding:'100px 0 100px 0', textAlign:"center"}}>
								<CircularProgress size={64} />
							</Box>
						</React.Fragment>		
					:
						<List>
							<ListItem className={classes.modifyButton} button onClick={() => setActivity(dialogActivityId, 'strava_update')} key={1}>
								<ListItemIcon><Icon icon={StravaIcon} style={{ color:'#4db6ac',fontSize: 40 }} /></ListItemIcon>
								<ListItemText primary={t('Dashboard.stravaUpdate')} secondary={t('Dashboard.stravaUpdateDesc')} />
							</ListItem>	
							<ListItem className={classes.modifyButton} button onClick={() => setActivity(dialogActivityId, 'reload')} key={1}>
								<ListItemIcon><PermDataSettingIcon style={{ color:'#4db6ac',fontSize: 36 }} /></ListItemIcon>
								<ListItemText primary={t('Dashboard.recalculateActivity')} secondary={t('Dashboard.recalculateActivityDesc')} />
							</ListItem>	
							{		
							(exclude_arr.indexOf(Number(dialogActivityId)) === -1) ? 
							<ListItem className={classes.modifyButton} button onClick={() => setActivity(dialogActivityId, 'deactivate')} key={2}>
								<ListItemIcon><RemoveCircleIcon style={{ color:'#4db6ac',fontSize: 36 }} /></ListItemIcon>
								<ListItemText primary={t('Dashboard.excludeActivity')} secondary={t('Dashboard.excludeActivityDesc')} />
							</ListItem>		
							:""	
							}				
							<ListItem className={classes.modifyButton} button onClick={() => setActivity(dialogActivityId, 'delete_activity')}  key={3}>
								<ListItemIcon><DeleteForeverIcon style={{ color:'#4db6ac',fontSize: 36 }} /></ListItemIcon>
								<ListItemText primary={t('Dashboard.deleteActivity')} secondary={t('Dashboard.deleteActivityDesc')} />
							</ListItem>						
						</List>
					}
						<Typography style={{textAlign:'center', marginBottom:'12px', color:'#999999'}}>{t('Dashboard.modifyActivityTerm')}</Typography>
					</DialogContent>
			</Dialog>

			<Dialog
					fullScreen={window.innerWidth < 960 ? true : false}
				  fullWidth={true}
					maxWidth={'xl'}					
					open={activityDialog}
					onClose={handleClose}
					scroll={'body'}
					PaperProps={{
						style: {							
							padding: '0px',
						}
					}}
				>
					<DialogTitle style={{padding: '8px'}}>
						<Box>
							<Button className={classes.activityTitleButton}>
								{"📝 " + activityName}		
							</Button>
							<IconButton 
								className={classes.activityTitleCloseButton}
								onClick={handleClose}
							>
								<CancelIcon />
							</IconButton>					
						</Box>
					</DialogTitle>
					<Divider />

					<DialogContent style={window.innerWidth < 960 ? {padding:"8px"} : {padding:"16px"}}>
						<Tabs
							className={classes.dialogTabs}
							value={chartType}
							variant="scrollable" 
							scrollButtons="auto"
							indicatorColor="primary"
							textColor="primary"
							onChange={handleTabChart}
						>							
							<Tab style={{minWidth:'0px'}} label={t('Activity.summary')} value={'stream'} />

							{/* 조건에 따라 차트 메뉴들이 보이고 안보이도록  */}
							{(streamDataJson.watts_5 > 1) ? <Tab style={{minWidth:'0px'}} label={t('Activity.powercurve')} value={'powercurve'} /> : ""}
							{(streamDataJson.watts_5 > 1) ? <Tab style={{minWidth:'0px'}} label={t('Activity.powerzone')} value={'powerzone'} /> : ""}
							{(streamDataJson.max_hr > 50) ? <Tab style={{minWidth:'0px'}} label={t('Activity.hrzone')} value={'hrzone'} /> : ""}
							{(streamDataJson.watts_60 > streamDataJson.ftp) ? <Tab style={{minWidth:'0px'}} label={t('Activity.interval')} value={'interval'} /> : ""}
							{(streamDataJson.lapl) ? <Tab style={{minWidth:'0px'}} label={t('Activity.lap')} value={'lap'} /> : ""}
							{(streamDataJson.watts_5 < 0) ? <Tab style={{minWidth:'0px'}} label={t('Activity.metabolism')} value={'metabolism'} />	: ""}					

						</Tabs>
						<ChartContent />
					</DialogContent>
					<DialogActions className={classes.dialogAction}>
						<Button onClick={handleClose} color="primary">
							Close
						</Button>
					</DialogActions>
			</Dialog>
		</div>
	);
};

Activities.propTypes = {
  className: PropTypes.string
};

export default withRouter(Activities);